export class SizeUtils {
  static validateSize(size) {
    let pass = false
    const r = size.split('*')
    if (r.length === 4) {
      pass = true
      for (const s of r) {
        const float = parseFloat(s)
        if (isNaN(float) || float === 0) {
          pass = false
          break
        }
      }
    }
    return pass
  }
}
